export function useErrorModal() {
  const isOpen = ref(false);
  const title = ref("Error");
  const message = ref("");

  const show = (msg: string, modalTitle = "Error") => {
    message.value = msg;
    title.value = modalTitle;
    isOpen.value = true;
  };

  const dismiss = () => {
    isOpen.value = false;
  };

  return { isOpen, title, message, show, dismiss };
}
